<template>
  <div class="digital">
    <div class="digital__header">
      <div class="digital__header__desktop digital-banner-desktop">
        <div class="digital__header__desktop__text">
          <h1 class="xlarge-title">Digital Advertising</h1>
          <p class="regular-font">Iklankan bisnis Anda kepada orang yang tepat untuk produk Anda.</p>
          <a href="/digital-advertising"><button type="button" class="btn-regular primary btn-digital">Buat Iklan</button></a>
        </div>
      </div>
      <div class="digital__header__mobile">
        <div class="digital__header__mobile__banner">
          <img :src="mobilebanner">
        </div>
        <div class="digital__header__mobile__text">
          <h1 class="xlarge-title">Digital Advertising</h1>
          <p class="regular-font">Iklankan bisnis Anda kepada orang yang tepat untuk produk Anda.</p>
          <a href="/digital-advertising"><button type="button" class="btn-regular primary btn-digital">Buat Iklan</button></a>
        </div>
      </div>
    </div>
    <div class="digital__content__text">
      <p>
        Advertising bukan hal mudah, dan kami ingin Anda sukses. Berikut ini beberapa opsi iklan digital untuk semua anggaran dan level keahlian, Anda dapat memulainya dari skala kecil atau langsung besar, dan Anda bisa selalu memantau kinerja iklan Anda dan melakukan perubahan kapan pun. Jangkau lebih banyak pelanggan untuk mendapatkan pengunjung baru untuk situs Anda, meningkatkan penjualan online, jumlah traffic di toko Anda, digital Advertising dapat membantu Anda. Beriklan secara lokal atau global, targetkan iklan Anda untuk pelanggan di negara, wilayah, atau kota tertentu atau dalam jarak tertentu dari bisnis atau toko Anda. Tampilkan iklan Anda di seluruh penjuru digital mulai dari Google Ads, Instagram Ads, Facebook Ads, dan SMS Blast.
      </p>
    </div>
    <div class="digital__content">
      <div class="digital__content__text-right">
        <div class="digital__content__text-right--left">
          <img class="digital__content__text-right__image" src="/img/landingpage/ad-word.jpg">
        </div>
        <div class="digital__content__text-right--right">
          <h3 class="medium-title">Iklan Adwords</h3>
          <p>Pasang iklan Anda di Google sekarang. Iklankan bisnis Anda tepat saat pelanggan mencari produk yang Anda tawarkan di Google. Bayar hanya jika ada yang mengklik iklan untuk mengunjungi situs atau menghubungi Anda.</p>
          <a href="/digital-advertising/adword"><button type="button" class="btn-regular primary btn-digital">Buat Iklan</button></a>
        </div>
      </div>
    </div>
    <div class="digital__content">
      <div v-if="!isMobile" class="digital__content__text-left">
        <div class="digital__content__text-left--left">
          <h3 class="medium-title">Iklan Facebook & Instagram</h3>
          <p>Bangun bisnis Anda di lebih dari 130 juta orang di Indonesia yang menggunakan Instagram & Facebook. Orang mengunjungi sosial media untuk menemukan hal yang penting bagi mereka, dan termasuk konten dari bisnis Anda. Jangkau orang-orang yang paling penting bagi Anda.</p>
          <a href="/digital-advertising/social-media"><button type="button" class="btn-regular primary btn-digital">Buat Iklan</button></a>
        </div>
        <div class="digital__content__text-left--right">
          <img class="digital__content__text-left__image" src="/img/landingpage/fb-ig.jpg">
        </div>
      </div>
      <div v-if="isMobile" class="digital__content__text-right">
        <div class="digital__content__text-right--left">
          <img class="digital__content__text-right__image" src="/img/landingpage/fb-ig.jpg">
        </div>
        <div class="digital__content__text-right--right">
          <h3 class="medium-title">Iklan Facebook & Instagram</h3>
          <p>Bangun bisnis Anda di lebih dari 130 juta orang di Indonesia yang menggunakan Instagram & Facebook. Orang mengunjungi sosial media untuk menemukan hal yang penting bagi mereka, dan termasuk konten dari bisnis Anda. Jangkau orang-orang yang paling penting bagi Anda.</p>
          <a href="/digital-advertising/social-media"><button type="button" class="btn-regular primary btn-digital">Buat Iklan</button></a>
        </div>
      </div>
    </div>
    <div class="digital__content">
      <div class="digital__content__text-right">
        <div class="digital__content__text-right--left">
          <img class="digital__content__text-right__image" src="/img/landingpage/sms-blast.png">
        </div>
        <div class="digital__content__text-right--right">
          <h3 class="medium-title">Iklan SMS Blast</h3>
          <p>Solusi layanan untuk bisnis Anda meraih konsumen Anda melalui SMS dengan menggunakan nomor handphone yang Anda punya dan bisa dikirimkan ke semua operator di Indonesia. SMS blast cocok digunakan untuk promosi semua tipe bisnis.</p>
          <a href="/digital-advertising/sms-blast"><button type="button" class="btn-regular primary btn-digital">Buat Iklan</button></a>
        </div>
      </div>
    </div>
    <div class="digital__content">
      <div v-if="!isMobile" class="digital__content__text-left">
        <div class="digital__content__text-left--left">
          <h3 class="medium-title">Iklan SMS targeted</h3>
          <p>Target penerima SMS yang disesuaikan dengan bisnis Anda mulai dari iklan di lokasi tertentu, jenis kelamin, tipe provider, umur, dan interest. Efektif dan tepat sasaran karena bisa membidik konsumen sesuai target yang di inginkan.</p>
          <a href="/digital-advertising/sms-targeted"><button type="button" class="btn-regular primary btn-digital">Buat Iklan</button></a>
        </div>
        <div class="digital__content__text-left--right no-padding">
          <img class="digital__content__text-left__image" src="/img/landingpage/sms-tergeted.png">
        </div>
      </div>
      <div v-if="isMobile" class="digital__content__text-right">
        <div class="digital__content__text-right--left no-padding">
          <img class="digital__content__text-right__image" src="/img/landingpage/sms-tergeted.png">
        </div>
        <div class="digital__content__text-right--right">
          <h3 class="medium-title">Iklan SMS targeted</h3>
          <p>Target penerima SMS yang disesuaikan dengan bisnis Anda mulai dari iklan di lokasi tertentu, jenis kelamin, tipe provider, umur, dan interest. Efektif dan tepat sasaran karena bisa membidik konsumen sesuai target yang di inginkan.</p>
          <a href="/digital-advertising/sms-targeted"><button type="button" class="btn-regular primary btn-digital">Buat Iklan</button></a>
        </div>
      </div>
    </div>
    <div class="digital__footer">
      <div class="digital__footer__text">
        <p class="medium-title first-capital">discuss your next advertising spot opportunity</p>
      </div>
      <div class="digital__footer__button">
        <a :href="'/contact-us?subject=digital'"><button type="button" class="btn-regular primary btn-digital">Start a Conversation</button></a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-digital',
  components: {

  },
  props: {

  },
  data() {
    return {
      mobilebanner: '/img/channel/digital-banner-mobile.jpg',
      desktoptopimage: '/img/channel/digital-banner-desktop.jpg',
      isMobile: document.documentElement.clientWidth <= 768 ? true : false
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getContentTopImage() {
      return this.isMobile ? this.mobiletopimage: this.desktoptopimage
    },
    getContentBottomImage() {
      return this.isMobile ? this.mobilebottomimage: this.desktopbottomimage
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>